import { render, staticRenderFns } from "./SHelp.vue?vue&type=template&id=a48c3b36&scoped=true&"
import script from "./SHelp.vue?vue&type=script&lang=ts&"
export * from "./SHelp.vue?vue&type=script&lang=ts&"
import style0 from "./SHelp.vue?vue&type=style&index=0&id=a48c3b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48c3b36",
  null
  
)

export default component.exports